<template>
  <div class="wrapper">
    <div>常用功能</div>
    <el-row :gutter="20" style="margin-top: 20px">
      <el-col :span="6"
        ><div class="card">
          <el-card> 添加试题 </el-card>
        </div></el-col
      >
      <el-col :span="6"
        ><div class="card">
          <el-card> 题库练习 </el-card>
        </div></el-col
      >
      <el-col :span="6"
        ><div class="card">
          <el-card> 新建考试 </el-card>
        </div></el-col
      >
      <el-col :span="6"
        ><div class="card">
          <el-card> 发起考试 </el-card>
        </div></el-col
      >
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'CommonExam-ExamIndex',
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  margin: 10px;
  padding: 20px;
  background: white;
  border-radius: 5px;
  .card {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
  }
}
</style>
